import moment from 'moment';
import { ReactComponent as WordFile } from 'assets/icons/word_icon.gov.svg';
import { ReactComponent as PdfFile } from 'assets/icons/pdf_icon.gov.svg';
import { ReactComponent as ExcelFile } from 'assets/icons/excel_icon.gov.svg';
import { ReactComponent as ImageFile } from 'assets/icons/image_icon.gov.svg';
import { ReactComponent as ZipFile } from 'assets/icons/zip_icon.gov.svg';

export const isExpiredDate = () => {
  const currentDateTime = new Date();
  //const expireDate = new Date(2025, 2, 31, 18, 0, 0); // 31/03/2025 και ώρα 18:00
  const expireDate = new Date(2025, 4, 16, 0, 0, 0);  // 31/05/2025 και ώρα 18:00
  return currentDateTime.getTime() > expireDate.getTime();
};

export const printInfo = (info) => {
    if (typeof info === "undefined" || info === null || info.length === 0) {
      return "-";
    } else {
      return info;
    }
  };

  export const printInfoRanges = (from,to) => {
    return from+' Από '+to;
  };

  export const getFullDateTime = date => {
    if (date == null) {
      return '-';
    } else {
      //console.log(date);
      const dt = Date.parse(date);
      if (isNaN(dt)) return '-';
      else return  moment(dt).local().format("DD/MM/YYYY HH:mm");
    }
  };

  export const getFullDateTimeWithSeconds = (date) => {
    if (date == null) {
      return "-";
    } else {
      //console.log(date);
      const dt = Date.parse(date);
      if (isNaN(dt)) return "-";
      else return moment(dt).local().format("DD/MM/YYYY HH:mm:ss");
    }
  };

  export const formatBytes = (bytes,decimals=2) =>{
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const getFileImage = (type) => {

  switch(type){
      case "word":
           return <WordFile/>;
      case "pdf":
           return <PdfFile/>;
      case "excel":
           return <ExcelFile/>;
      case "image":
           return <ImageFile/>;
      case "content":
              return <ZipFile/>;  
      default:
           return "";                     
  }

};

export const getFullDateHours = (date) => {

  if(typeof date ==="undefined" || date === null || date.length === 0){
      return "-";
  }
  else{
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
  }
};